<template>
  <div class="Set_basis">
    <ul class="nav">
      <li class="nac-li1">
        <div class="nac-li1-top1">

          <div style="height: 70px;width: 100%;">
            <h2 style="padding:20px;width: 200px;float: left;">危机个案统计</h2>
            <p style="float: right;padding:20px;">年份：<el-date-picker @change="crisisCaseStatistics()" value-format="yyyy" v-model="YearParam"  type="year" placeholder="选择年"></el-date-picker></p>
          </div>
          
          <ul style="height: 120px;width: 100%;">

            <li>
              <p style="width: 100%;padding-top:10px;color: rgba(117, 124, 133, 100);text-indent:15px;font-size: 15px;">上报总人数(人)</p>
              <p style="font-size: 25px;font-weight: 700;text-indent:15px;margin-top:10px;">{{crisis.reportTotalNumber}}</p>
            </li>

            <li>
              <p style="width: 100%;padding-top:10px;color: rgba(117, 124, 133, 100);text-indent:15px;font-size: 15px;">危机干预中(人)</p>
              <p style="font-size: 25px;font-weight: 700;text-indent:15px;margin-top:10px;">{{crisis.interventionInProgress}}</p>
            </li>

            <li>
              <p style="width: 100%;padding-top:10px;color: rgba(117, 124, 133, 100);text-indent:15px;font-size: 15px;">今日新增人数(人)</p>
              <p style="font-size: 25px;font-weight: 700;text-indent:15px;margin-top:10px;">{{crisis.todayAdd}}</p>
            </li>

            <li>
              <p style="width: 100%;padding-top:10px;color: rgba(117, 124, 133, 100);text-indent:15px;font-size: 15px;">已完成(人)</p>
              <p style="font-size: 25px;font-weight: 700;text-indent:15px;margin-top:10px;">{{crisis.completed}}</p>
            </li>

          </ul>

        </div>

        <div class="nac-li1-top2">
          
          <h2 style="padding:20px;width: 200px;">常用功能</h2>

          <ul>
            <li style="text-align:center" v-for="(item,i) in functionConfig" :key="i" @click="gourl(item.linkURL)">
              <img style="width: 50px;height: 50px;line-height:50px;" :src="url+item.functionLogo" alt="">
              <p>{{item.function}}</p>
            </li>
          </ul>

        </div>

        <div class="nac-li1-top3">
          <div class="nac-li1-top1">
            <div style="height: 85px;width: 100%;">
              <h2 style="padding:20px;width: 200px;float: left;">测评情况</h2>

              <p style="float: right;padding:20px;">主题：
                <el-select v-model="PublishID" placeholder="请选择主题" @change="evaluationSituation">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="(item,i) in GetSubjectPublish" :key="i" :label="item.PublishSubject" :value="item.PublishID"></el-option>
                </el-select>
              </p>
              <p style="float: right;padding:20px;">年份：<el-date-picker value-format="yyyy" @change="evaluationSituation" v-model="YearParamtwo" type="year" placeholder="选择年"></el-date-picker></p>

              
            </div>
            <ul style="height: 120px;width: 100%;">

              <li>
                <p style="width: 100%;padding-top:10px;color: rgba(117, 124, 133, 100);text-indent:15px;font-size: 15px;">测评总人次</p>
                <p style="font-size: 25px;font-weight: 700;text-indent:15px;margin-top:10px;">{{SituationStatistics.paperresultCount}}</p>
              </li>

              <li>
                <p style="width: 100%;padding-top:10px;color:rgba(117, 124, 133, 100);text-indent:15px;font-size: 15px;">累计预警人数</p>
                <p style="font-size: 25px;font-weight: 700;text-indent:15px;margin-top:10px;">{{SituationStatistics.combineresultCount}}</p>
              </li>

              <li>
                <p style="width: 100%;padding-top:10px;color: rgba(117, 124, 133, 100);text-indent:15px;font-size: 15px;">今日测评人次</p>
                <p style="font-size: 25px;font-weight: 700;text-indent:15px;margin-top:10px;">{{SituationStatistics.paperresultTodayCount}}</p>
              </li>

              <li>
                <p style="width: 100%;padding-top:10px;color: rgba(117, 124, 133, 100);text-indent:15px;font-size: 15px;">已发布测评数</p>
                <p style="font-size: 25px;font-weight: 700;text-indent:15px;margin-top:10px;">{{SituationStatistics.publishedCount}}</p>
              </li>

            </ul>
          </div>

          <div>
            <h2 style="padding:20px;width: 200px;">最近测试<span style="font-size: 14px;font-weight: 500;">  (最近五次)</span></h2>
            <ul class="ces">

              <li style="background: rgba(237, 242, 245, 1);">
                <span style="display: inline-block;width: 18%;text-indent:20px;">发布主题</span>
                <span style="display: inline-block;width: 16%;text-align:center;">未完成人数</span>
                <span style="display: inline-block;width: 20%;text-align:center;">已完成人数</span>
                <span style="display: inline-block;width: 20%;text-align:center;">测试进度</span>
                <span style="display: inline-block;width: 20%;text-align:center;">测试结束日期</span>
              </li>

              <li v-for="(item,i) in evaluationStatistics" :key="i" :class="isEvenOrOdd(i)?'aa':'ss'">
                <span style="display: inline-block;width:18%;text-indent:20px;"> {{item.publishSubject}}</span>
                <span style="display: inline-block;width:16%;text-align:center;">{{item.incomplete}}</span>
                <span style="display: inline-block;width:20%;text-align:center;">{{item.completed}}</span>
                <span style="display: inline-block;width:20%;text-align:center;">{{item.testProgress}}</span>
                <span style="display: inline-block;width:20%;text-align:center;">{{item.testEnd}}</span>
              </li>

            </ul>
          </div>
        </div>
      </li>

      <li class="nac-li2">

        <div class="nac-li2-top1">
          <h2 style="padding:20px;width: 200px;">危机来源渠道</h2>
          <div ref="myechart" style="width: 260px; height: 300px;float: left;"></div>

          <div style="width: 180px; height: 300px;float: left;">

            <div style="margin-top:10px;margin-left:30px;position: relative;">
              <p style="position: absolute;height: 8px;width: 8px;border-radius:8px;background:rgba(254, 150, 71, 1);top:20px;left:-20px"></p>
              <p style="font-size: 16px;">{{crisis.dailyCrisis}}人 | {{crisis.dailyCrisisRatio}}%</p>
              <p style="color: rgba(102, 102, 102, 100);margin-top:4px">日常危机上报</p>
            </div>

            <div style="margin-top:20px;margin-left:30px;position: relative;">
              <p style="position: absolute;height: 8px;width: 8px;border-radius:8px;background:rgba(87, 162, 247, 1);top:20px;left:-20px"></p>
              <p style="font-size: 16px;">{{crisis.psychometrics}}人 | {{crisis.psychometricsRatio}}%</p>
              <p style="color: rgba(102, 102, 102, 100);margin-top:4px">心理测评</p>
            </div>

            <div style="margin-top:20px;margin-left:30px;position: relative;">
              <p style="position: absolute;height: 8px;width: 8px;border-radius:8px;background:rgba(123, 224, 112, 1);top:20px;left:-20px"></p>
              <p style="font-size: 16px;">{{crisis.selfReport}}人 | {{crisis.selfReportRatio}}%</p>
              <p style="color: rgba(102, 102, 102, 100);margin-top:4px">自主上报</p>
            </div>

            <div style="margin-top:20px;margin-left:30px;position: relative;">
              <p style="position: absolute;height: 8px;width: 8px;border-radius:8px;background:rgba(172, 127, 250, 1);top:20px;left:-20px"></p>
              <p style="font-size: 16px;">{{crisis.consultationReport}}人 | {{crisis.consultationReportRatio}}%</p>
              <p style="color: rgba(102, 102, 102, 100);margin-top:4px">咨询上报</p>
            </div>

            <div style="margin-top:20px;margin-left:30px;position: relative;">
              <p style="position: absolute;height: 8px;width: 8px;border-radius:8px;background:rgba(230, 104, 76, 1);top:20px;left:-20px"></p>
              <p style="font-size: 16px;">{{crisis.hotReport}}人 | {{crisis.hotReportRatio}}%</p>
              <p style="color: rgba(102, 102, 102, 100);margin-top:4px">热线上报</p>
            </div>
            
          </div>
        </div>

        <div class="nac-li2-top2">
          <h2 style="padding:20px;width: 200px;">待办事项</h2>
          <ul>
            <li v-for="(item,i) in functionConfig2" :key="i" @click="gourl(item.linkURL)">
              <img style="width: 50px;height: 50px;line-height:50px;" :src="url + item.functionLogo" alt="">
              <p>{{item.function}}</p>
            </li>
          </ul>
        </div>

      </li>

    </ul>
  </div>
</template>
<script>

export default {
  data() {
    return {
      YearParam:'',
      YearParamtwo:'',
      crisis:'',
      region:'',
      evaluationStatistics:'',
      functionConfig:'',
      functionConfig2:'',
      GetSubjectPublish:'',
      url:'',
      PublishID:'',
      SituationStatistics:'',
    }
  },
  methods: {
    evaluationSituation(){

      this.$Http_Post('/workbench/evaluationSituationStatistics', {PublishID:this.PublishID,YearParam:this.YearParamtwo}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.SituationStatistics = res.Data;
        }else{
          this.Global.request_failure(res.Message);
        }
      })

    },
    gourl(linkURL){
      this.$router.push(linkURL);
    },
    isEvenOrOdd(num) {
      if(num % 2 === 0) {
        return true;
      } else {
        return false;
      }
    },
    crisisCaseStatistics(){
      this.$Http_Post('workbench/crisisCaseStatistics', {YearParam:this.YearParam}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.crisis = res.Data;
          this.myechartfun();
        }
      })
    },
    myechartfun(){
      var myCharts = this.$echarts.init(this.$refs.myechart);//指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: 'item',
        },
        series: [
          {
            name: '类型',
            type: 'pie',
            radius: ['45%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              {value:this.crisis.dailyCrisis, name: '日常危机上报',itemStyle: {color:'rgba(254, 150, 71, 1)'}},
              {value:this.crisis.psychometrics, name: '心理测评', itemStyle:{color:'rgba(87, 162, 247, 1)'}},
              {value:this.crisis.selfReport, name: '自主上报', itemStyle:{color:'rgba(123, 224, 112, 1)'}},
              {value:this.crisis.consultationReport, name: '咨询上报', itemStyle:{color:'rgba(172, 127, 250, 1)'}},
              {value:this.crisis.hotReport, name: '热线上报',itemStyle:{color:'rgba(230, 104, 76, 1)'}}
            ]
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      myCharts.setOption(option);
    }

  },
  mounted() {
    this.url = process.env.VUE_APP_URL
    const currentTime = new Date();
    this.YearParam = currentTime.getFullYear().toString();
    this.YearParamtwo = currentTime.getFullYear().toString();
    this.crisisCaseStatistics();
    this.$Http_Post('/workbench/evaluationStatistics').then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.evaluationStatistics = res.Data;
      }
    })
    this.$Http_Post('/workbench/functionConfig', { Type: 1}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.functionConfig = res.Data;
      }
    })
    this.$Http_Post('/workbench/functionConfig', { Type: 2}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.functionConfig2 = res.Data;
      }
    })
    this.$Http_Post('/EmphasisClarification/GetSubjectPublish').then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.GetSubjectPublish = res.Data;
      }
    })
    this.evaluationSituation();
  },
  updated() {

  },

}
</script>
<style>
.Set_basis{height: 100%;width: 100%;min-height: 1100px;min-width: 1800px;}
.Set_basis .nav {height: 100%;width: 100%;}
.Set_basis .nav li{float: left;}
.Set_basis .nav .nac-li1{width: calc(100% - 470px);height: 100%;}
.Set_basis .nav .nac-li2{width: 450px;margin-left: 20px;height: 100%;}
.Set_basis .nav .nac-li1 .nac-li1-top1{background: #fff;height: 200px;border-radius: 10px;}
.Set_basis .nav .nac-li1 .nac-li1-top1 ul li{width: 180px;height: 90px;margin-left: 20px;border-radius: 4px;background: rgba(244, 249, 253, 1);margin-top: 15px;}
.Set_basis .nav .nac-li1 .nac-li1-top2{background: #fff;height: 200px;border-radius: 10px;margin-top: 20px;}
.Set_basis .nav .nac-li1 .nac-li1-top2 ul li{width: 180px;height: 90px;margin-left: 20px;border-radius: 4px;margin-top: 15px;}
.Set_basis .nav .nac-li1 .nac-li1-top3{background: #fff;border-radius: 10px;margin-top: 20px;height: calc(100% - 440px);}
.Set_basis .nav .nac-li2 .nac-li2-top1{background: #fff;height:420px;border-radius: 10px;}
.Set_basis .nav .nac-li2 .nac-li2-top2{background: #fff;border-radius: 10px;height: calc(100% - 440px);margin-top: 20px;}
.Set_basis .ces{width: calc(100% - 40px);margin-left: 20px;}
.Set_basis .ces li{height: 50px;line-height: 50px;width: 100%;}

.Set_basis .nac-li2-top2 li{float: left;width: 180px;height: 90px;margin-left: 30px;margin-top: 20px;text-align: center;}
/* .Set_basis .aa{background: rgba(237, 242, 245, 1);} */
.Set_basis .ss{background: rgba(235, 242, 252, 1);}
</style>
